import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const CheckIcon = ({
  width=20,
  height=17,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 17" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.255 16.503 19.6 3.826 16.393.533 7.257 9.916 3.604 6.165.398 9.457l3.653 3.751-.002.002 3.206 3.293z"
        fill={strokeColor}
      />
    </svg>
  )
}

export default CheckIcon
